var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("GSDescription", {
        staticClass: "reward-description",
        attrs: { imgUrl: _vm.rewardImg, text: _vm.getBindPhoneDescription() }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bind-input" },
        [
          _vm.bindPhone
            ? _c("GSDropDownInput", {
                attrs: {
                  dropdownPlaceholder: _vm.$t("lbl__select_country_region"),
                  dropdownItems: _vm.countryCodeList,
                  inputPlaceholder: _vm.$t("lbl__input_phone_number"),
                  inputDigitOnly: true,
                  inputType: "tel"
                },
                on: { changed: _vm.updatePhoneNumber }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.bindEmail
            ? _c("GSInput", {
                attrs: { placeholder: _vm.$t("lbl__input_email") },
                on: { changed: _vm.updateEmailAddress }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("GSRecaptcha", {
        ref: "gsrecaptcha",
        staticClass: "recaptcha-widget",
        attrs: {
          onVerify: _vm.onVerifyRecaptcha,
          language: _vm.recaptchaLanguage
        }
      }),
      _vm._v(" "),
      _c("GSButton", {
        staticClass: "submit-button",
        attrs: { text: _vm.$t("btn__submit") },
        on: { clicked: _vm.submit }
      }),
      _vm._v(" "),
      _c("GSAgreement", {
        attrs: {
          text: _vm.$t("lbl__user_agreement_{privacy_policy}"),
          privacyPolicy: _vm.$t("lbl__privacy_policy")
        },
        on: { clicked: _vm.showPolicyPopup }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d71e416c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d71e416c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bind/BindPage.vue
// module id = null
// module chunks = 